// ag-grid第一列序号组件
import { defineComponent, PropType, ref, h } from 'vue';
import { ICellRendererParams, RowEvent } from 'ag-grid-community';

export default defineComponent({
  props: {
    params: { type: Object as PropType<ICellRendererParams>, required: true }
  },

  setup(props) {
    const seq = ref<any>((props.params.node.rowIndex ?? 0) + 1);

    // rowPinned不需要序号
    if (props.params.node.rowPinned) {
      // eslint-disable-next-line vue/no-setup-props-destructure
      seq.value = props.params.value;
    } else {
      // index变更处理
      props.params.node.addEventListener(
        'rowIndexChanged',
        (event: RowEvent) => {
          seq.value = (event.node.rowIndex ?? 0) + 1;
        }
      );
    }

    return { seq };
  },

  render() {
    return h('span', this.seq);
  }
});
